import React, { Fragment, useState } from 'react'
import { map, filter, includes } from 'lodash'
import ReactTable from 'react-table-v6'
import BooleanIcon from 'UI/BooleanIcon'

const cardStyles = {
  card: {
    boxShadow: '0 6px 12px rgba(140,152,164,.075)',
    position: 'relative',

    display: 'flex',
    msFlexDirection: 'column',
    flexDirection: 'column',
    minWidth: '0',
    wordWrap: 'break-word',
    backgroundColor: '#fff',
    backgroundClip: 'border-box',
    border: '.0625rem solid rgba(231, 234, 243, .7)',
    borderRadius: '.75rem',
  },
  cardBody: {
    flex: '1 1 auto',
    minHeight: '1px',
    padding: '1.3125rem',
  },
  cardHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem',
    fontWeight: '600',
    fontSize: '1.1em'
  }
}

const tabButtonStyles = {
  backgroundColor: '#6C757D',
  fontSize: '.8125rem',
  padding: '.4375rem .65625rem',
  borderRadius: '.3125rem',
}

const activeButtonStyle = {
  ...tabButtonStyles,
  backgroundColor: '#FFF',
  color: '#1E2022'
}

const notBackedUpColumns = [
  { Header: 'VM', accessor: 'name' },
  { Header: 'Site', accessor: 'siteName' },
  { Header: 'Cluster', accessor: 'clusterName' },
  { Header: 'Pool', accessor: 'resourcePoolName' },
  { Header: 'Customer', accessor: 'customer.name' },
  {
    Header: 'Power State',
    accessor: 'power_state',
    Cell: ({ value: powerState }) => (
      <BooleanIcon {...{
        booleanValue: powerState === 'PoweredOn',
        trueIcon: { text: powerState.replace('Powered', ''), icon: 'power-off' },
        falseIcon: { text: powerState.replace('Powered', ''), icon: 'power-off' }
      }} />
    )
  },
  {
    Header: 'In Commvault',
    accessor: 'inCommvault',
    Cell: ({ value }) => (
      <BooleanIcon booleanValue={value} />
    )
  },
]

const orphanedVmColumns = [
  { Header: 'VM', accessor: 'name' }
]

const Card = ({ header, subtitle, subtitleActions, children }) => (
  <div style={cardStyles.card}>
    {header && (
      <div style={cardStyles.cardHeader}>
        {header}
      </div>
    )}
    <div style={cardStyles.cardBody}>
      <div className="row">
        <div className="col-6">
          <h6 className="card-subtitle">{subtitle}</h6>
        </div>
        <div className="col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {subtitleActions}
        </div>
      </div>

      {children}
    </div>
  </div>
)

const CardTable = ({ header, headerActions, children }) => (
  <div style={cardStyles.card}>
    <div className="row" style={cardStyles.cardHeader}>
      <div className="col-6">
        <div>{header}</div>
      </div>
      <div className="col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {headerActions}
      </div>
    </div>

    {children}
  </div>
)

const CommvaultAssetReport = ({ data = {} }) => {
  const { commcells, notBackedUpVms, backedUpWithErrorsVms, vcenters, orphanedCommvaultVms } = data
  const vmTypes = ['Not protected', 'Completed with errors']
  const [inCommvaultFilter, setInCommvaultFilter] = useState(false)
  const [commvaultVmTypeFilter, setCommvaultVmTypeFilter] = useState(vmTypes[0])

  return (
    <div className='row' style={{ marginTop: '20px' }}>
      <div className='col' style={{ paddingLeft: 0 }}>
        <CardTable header='Not backed up' headerActions={
          <div className="btn-group" role="group" style={{ background: '#6C757D', padding: '2px', borderRadius: '5px' }}>
            {map(vmTypes, vmType => (
              <button style={commvaultVmTypeFilter === vmType ? activeButtonStyle : tabButtonStyles} onClick={() => setCommvaultVmTypeFilter(vmType)} type="button" className="btn btn-secondary">
                {vmType}
              </button>
            ))}
          </div>
        }>
          <ReactTable
            data={commvaultVmTypeFilter === 'Not protected' ? notBackedUpVms : backedUpWithErrorsVms}
            columns={notBackedUpColumns}
            minRows={0}
            filterable
            defaultFilterMethod={(filter, row) => includes(row[filter.id], filter.value)}
            defaultPageSize={10}
          />
        </CardTable>
      </div>

      {/* <div className='col-6' style={{ paddingRight: 0 }}>
        <div className="row">
          <div className="col">
            <Card subtitle='vCenters' subtitleActions={
              <div className="btn-group" role="group" style={{ background: '#6C757D', padding: '2px', borderRadius: '5px'}}>
                <button style={inCommvaultFilter === false ? activeButtonStyle : tabButtonStyles} onClick={() => setInCommvaultFilter(false)} type="button" className="btn btn-secondary">Not In Commvault</button>
                <button style={inCommvaultFilter === true ? activeButtonStyle : tabButtonStyles} onClick={() => setInCommvaultFilter(true)} type="button" className="btn btn-secondary">In Commvault</button>
              </div>
            }>
              <ul className='list list-unstyled'>
                {map(filter(vcenters, ['inCommvault', inCommvaultFilter]), vcenter => (
                  <li>
                    {vcenter.site_code}: {vcenter.name}
                  </li>
                ))}
              </ul>
            </Card>
          </div>
        </div>
        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col">
            <CardTable header='Orphaned Commvault Backups'>
              <ReactTable
                data={orphanedCommvaultVms}
                columns={orphanedVmColumns}
                minRows={0}
                defaultPageSize={10}
              />
            </CardTable>
          </div>
        </div>

      </div> */}
    </div>
  )
}

export default CommvaultAssetReport
